var render, staticRenderFns
import script from "./VuesticPopup.vue?vue&type=script&lang=js"
export * from "./VuesticPopup.vue?vue&type=script&lang=js"
import style0 from "./VuesticPopup.vue?vue&type=style&index=0&id=14f196a0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14f196a0')) {
      api.createRecord('14f196a0', component.options)
    } else {
      api.reload('14f196a0', component.options)
    }
    
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-popup/quasar/components/popup/VuesticPopup.vue"
export default component.exports